import { Component, Input, OnInit } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../../app/store';
import { scrollTo } from '../../common';
import {IMessage} from '../../api/interfaces/Messages/IMessage';
import {useDefault} from '../../common/common';
import {MessageCategory} from '../../api/model/message/message-category.model';

@Component({
  selector: 'stay-mgmt-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  messages: IMessage[];
  state: IAppState;
  @Input() messageCategory: MessageCategory;

  @Input() translations;

  constructor(private _ngRedux: NgRedux<IAppState>) { }

  ngOnInit() {
    this.updateFromState();
    this._ngRedux.subscribe( () => {
      this.updateFromState();
      if (this.messages.length > 0) {
        scrollTo('message-container', false);
      }
    });
  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    this.messages = this._filterMessages(this.state.messages);
  }

  private _filterMessages(messages: IMessage[]) {
    const selectedCategory: MessageCategory = useDefault(this.messageCategory, MessageCategory.ALL);
    return messages ? messages.filter((message) => {return selectedCategory === MessageCategory.ALL || selectedCategory ===  useDefault(message.messageCategory, MessageCategory.ALL)}) : [];
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/messages/messages.component.ts